/**
 * Edad legible y límites de una fecha de nacimiento.
 *
 * En pediatría la edad no se dice en años: un bebé tiene "3 meses" y un recién
 * nacido "12 días". Redondearlo todo a "0 años" borra justo la información que
 * usa quien dosifica un jarabe.
 */

/** Hoy en formato YYYY-MM-DD, que es lo que entiende un <input type="date">. */
export function hoyISO(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
    d.getDate(),
  ).padStart(2, "0")}`;
}

/** Nadie que se atienda hoy nació antes de esto. Evita el 0025 por un dedazo. */
export const FECHA_MINIMA = "1900-01-01";

export function edadEnAnios(fecha: string | null | undefined): number | null {
  if (!fecha) return null;
  const n = new Date(`${fecha}T00:00:00`);
  if (Number.isNaN(n.getTime())) return null;
  const hoy = new Date();
  let e = hoy.getFullYear() - n.getFullYear();
  const m = hoy.getMonth() - n.getMonth();
  if (m < 0 || (m === 0 && hoy.getDate() < n.getDate())) e -= 1;
  return e;
}

/**
 * "34 años", "8 meses", "12 días". Devuelve null si la fecha no sirve, y
 * avisa si es futura: una fecha de nacimiento en el futuro es un dedazo, no
 * una edad negativa.
 */
export function edadLegible(fecha: string | null | undefined): string | null {
  if (!fecha) return null;
  const n = new Date(`${fecha}T00:00:00`);
  if (Number.isNaN(n.getTime())) return null;
  const hoy = new Date();
  if (n > hoy) return "fecha futura";

  const anios = edadEnAnios(fecha) ?? 0;
  if (anios >= 2) return `${anios} años`;

  const meses =
    (hoy.getFullYear() - n.getFullYear()) * 12 +
    (hoy.getMonth() - n.getMonth()) -
    (hoy.getDate() < n.getDate() ? 1 : 0);
  if (meses >= 1) return `${meses} ${meses === 1 ? "mes" : "meses"}`;

  const dias = Math.floor((hoy.getTime() - n.getTime()) / 86_400_000);
  return `${dias} ${dias === 1 ? "día" : "días"}`;
}
